import { container } from 'hoc'
import Component from './unauthorized'

const intl = 'screen.unauthorized'
const screenName = 'unauthorized'

export default container({
  intl, screenName,
})(Component)
